import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormValidationError from '@shared/form/form-validation-error/form-validation-error';
import FieldLabel from '@shared/form/field-label/field-label';
import { InputProps } from '../../../../types/form.types';
import FormTextareaComponents from './form-textarea.components';

const { Container, StyledTextarea } = FormTextareaComponents;

const FormTextarea: React.FunctionComponent<InputProps> = ({
  name,
  label,
  errorMessage,
  isRequired,
  showRequiredLegend
}) => {
  const { register } = useFormContext();
  return register ? (
    <Container>
      <FieldLabel
        text={label}
        isRequired={isRequired}
        showLegend={showRequiredLegend}
      />
      <StyledTextarea rows={6} {...register(name)} data-test-id={name} />

      <FormValidationError errorMessage={errorMessage} />
    </Container>
  ) : null;
};

export default FormTextarea;
